import { render, staticRenderFns } from "./PaginationResultsFront.vue?vue&type=template&id=bca16498"
import script from "./PaginationResultsFront.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationResultsFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports